// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { debug16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-debug': IconDebug;
    }
}

/**
 * The icon component for the 'debug' icon
 */
export class IconDebug extends Icon {
    public constructor() {
        super(debug16X16);
    }
}

registerIcon('icon-debug', IconDebug);
export const iconDebugTag = 'nimble-icon-debug';
